import { Provider } from '@angular/core';

import { CommentUseCasesImpl } from '@app/domain/use-cases/comment/comment.use-cases';
import { COMMENT_USE_CASES } from '@app/domain/use-cases/comment/comment.use-cases.contract';

export const commentUseCasesProvider: Provider = {
  provide: COMMENT_USE_CASES,
  useClass: CommentUseCasesImpl
};
